import React from "react";
import Select from "react-select";
import moment from "moment-timezone";

const BILLING_TIMEZONE = "America/Chicago";
const FIRST_MONTH = "02-2021"; // first month of ledger billing = Feb 2021

class MonthPicker extends React.Component {
  constructor(props) {
    super(props);
  }

  _generateMonths() {
    let curr = moment(FIRST_MONTH, "MM-YYYY")
      .tz(BILLING_TIMEZONE)
      .startOf("month");
    let end = moment().tz(BILLING_TIMEZONE).startOf("month");

    let months = [];

    while (curr) {
      if (curr <= end) {
        months.push({
          value: curr.format("MM-YYYY"),
          label:
            curr.diff(end) === 0
              ? moment().tz(BILLING_TIMEZONE).format("MMMM [1]–D, YYYY")
              : curr.format("MMMM YYYY"),
          _end: moment(curr).endOf("month")
        });
        curr.add(1, "month");
      } else {
        curr = null;
      }
    }

    return months.reverse();
  }

  render() {
    const months = this._generateMonths();
    return (
      <Select
        clearable={false}
        value={this.props.value}
        options={months}
        onChange={e => this.props.onChange(e.value)}
      />
    );
  }
}

MonthPicker.getCurrentMonth = () => {
  return moment().tz(BILLING_TIMEZONE).startOf("month").format("MM-YYYY");
};

export default MonthPicker;



// WEBPACK FOOTER //
// ./src/app/components/partials/month-picker.jsx